<template>
  <div>
    <v-select
      v-model="inputedValue"
      item-text="label"
      item-value="value"
      :items="items"
      dense
      outlined
      return-object
      class="original-selectbox"
      hide-details
      :placeholder="$t('common.input_unselected_2')"
      :height="height"
      width="80%"
      clearable
    >
    </v-select>
  </div>
</template>

<script>
import { stockMoveUtil } from '@/util'

export default {
  components: {
    //
  },
  props: {
    value: {},
    type: Number,
    height: { default: '32px' }
  },
  data: () => ({
    items: []
    // test: {}
  }),
  created() {
    this.items = stockMoveUtil.getStockMoveStatusListForSelectBox()
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
